import { Box } from "@mui/material";
import Drawer from "@mui/material/Drawer";

function CustomDrawer({ children, sx = [], containerSx = [], ...props }) {
  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      container={document.getElementById("AppContainer")}
      sx={[
        {
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          "& .MuiBackdrop-root": { position: "absolute" },
          "& .MuiPaper-root": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            bgcolor: "unset",
            boxShadow: "unset",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...props}
    >
      <Box
        sx={[
          {
            py: "24px",
            px: "24px",
            pb: `calc(env(safe-area-inset-bottom) + 24px )`,
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
            display: "flex",
            flexDirection: "column",
            bgcolor: "common.white",
            width: "100%",
            maxWidth: 600,
          },
          ...(Array.isArray(containerSx) ? containerSx : [containerSx]),
        ]}
      >
        {children}
      </Box>
    </Drawer>
  );
}

export default CustomDrawer;
